import { Cart, Product } from '@diamond/shared/types';
import { calculateFinalPrice } from '@diamond/shared/utils';

export const calculateCartTotal = (items: Cart[]): number => {
  return items.reduce((sum, item) => {
    const finalPrice = calculateFinalPrice(item.product, item.quantity / 1000);
    return sum + finalPrice * (item.quantity / 1000);
  }, 0);
};

export const getPromoForTracking = (product: Product) => {
  const discountPromo = product.discount_promos?.[0];
  const bundledDiscountPromo = product.bundled_discount_promos?.[0];
  const freeGoods = product.free_good_promos?.[0];
  const bundledFreeGoods = product.bundled_free_good_promos?.[0];

  return (
    bundledDiscountPromo ||
    discountPromo ||
    bundledFreeGoods ||
    freeGoods ||
    null
  );
};

export const calculateDiscountAmount = (
  product: Product,
  finalPrice: number
): number => {
  const regularPrice = product.prices?.[0]?.price || 0;
  return regularPrice > finalPrice ? regularPrice - finalPrice : 0;
};
